export enum COMMON_OFF_CANVAS_IDS {
  COPY_AND_SHARE_LINK = 'COPY_AND_SHARE_LINK',
}
